// import i18nFunctions from "client/utils/i18n";
import FireBase from "client/services/fireBase/apis";
// import handlers from "client/utils/fireBase/cloudFunctions/handlers";
// import { fireBaseAnalytics } from "client/services/fireBase/firebaseConfig";

const onPageInit = async (props) => {
  const { currentUser } = props;

  const userDetails = await FireBase.getUserDetails({ currentUser });

  const onPageInitProps = {
    certificationName: "webDev-S",
    userDetails,
  };

  return onPageInitProps;
};

const onProgressChange = async (props) => {
  // const { currentUser, currentProgress, selectedCourse, videoId } = props;
  // const newProgress = await handlers.updateProgressData(
  //   currentUser,
  //   currentProgress,
  //   selectedCourse,
  //   videoId
  // );
  // const updateProgressResponse = await FireBase.updateProgress({
  //   currentUser,
  //   newProgress,
  // }).then((myJson) => {
  //   if (myJson?.status === "success" && myJson?.data?.success) {
  //     return myJson?.data?.content;
  //   }
  //   return [];
  // });
  // const updatedProgressData = updateProgressResponse[0]?.userData;
  // return updatedProgressData;
};

const onSubmit = async (props) => {
  const {
    uid,
    certificationName,
    fullName,
    email,
    phoneNumber,
    qualification,
    universityName,
    semester,
    educationField,
    referralCode,
    submissionDate,
    cohort,
  } = props;

  const REQUEST_BODY = {
    uid,
    certificationName,
    fullName,
    email,
    phoneNumber,
    qualification,
    universityName,
    semester,
    educationField,
    referralCode,
    submissionDate,
    cohort,
  };

  // fireBaseAnalytics.logEvent("courses_visited_back");
  // const REQUEST_BODY = {
  //   uid: "oyIdgibCGHOFAZtbOoCtORrgEaJ2",
  //   certification: "dataSci-G",
  //   firstName: "Raheel",
  //   lastName: "Ahmed",
  //   email: "raheel@thedevnation.com",
  //   phoneNumber: "+923244004778",
  //   gender: "Male",
  //   city: "Lahore",
  //   referralCode: "",
  //   universityName: "NYU",
  //   universitySemester: "8",
  // };
  await FireBase.createApplication(REQUEST_BODY);

  // const REQUEST_BODY1 = {
  //   uid,
  //   certificationName,
  // };

  // const REQUEST_BODY2 = {
  //   uid,
  //   certificationName,
  //   paid: true,
  // };

  // const data1 = await FireBase.retrieveApplication(REQUEST_BODY1);

  // const data2 = await FireBase.updateApplicationPayment(REQUEST_BODY2);
};

const functions = { onPageInit, onProgressChange, onSubmit };

export default functions;
